"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _script = _interopRequireDefault(require("next/script"));

var _client = require("@apollo/client");

var _LoadingOutlined = _interopRequireDefault(require("@ant-design/icons/LoadingOutlined"));

var _spin = _interopRequireDefault(require("antd/lib/spin"));

var _Fb = _interopRequireWildcard(require("@meepshop/context/lib/Fb"));

var _useFb2 = _interopRequireDefault(require("./hooks/useFb"));

var _gqls = require("./gqls");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
// graphql import
// definition
var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var children = _ref.children;

  var _useQuery = (0, _client.useQuery)(_gqls.getFbAppId),
      data = _useQuery.data;

  var _useMemo = (0, _react.useMemo)(function () {
    var _data$viewer, _data$viewer$store, _data$viewer2, _data$viewer2$store;

    var storeIsLoginEnabled = data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : (_data$viewer$store = _data$viewer.store) === null || _data$viewer$store === void 0 ? void 0 : _data$viewer$store.facebookSetting.isLoginEnabled;
    var storeAppId = storeIsLoginEnabled ? data === null || data === void 0 ? void 0 : (_data$viewer2 = data.viewer) === null || _data$viewer2 === void 0 ? void 0 : (_data$viewer2$store = _data$viewer2.store) === null || _data$viewer2$store === void 0 ? void 0 : _data$viewer2$store.facebookSetting.appId : null;
    return {
      isLoginEnabled: Boolean(storeIsLoginEnabled && storeAppId),
      appId: (storeIsLoginEnabled ? storeAppId : null) || _Fb.defaultAppId
    };
  }, [data]),
      isLoginEnabled = _useMemo.isLoginEnabled,
      appId = _useMemo.appId;

  var _useFb = (0, _useFb2["default"])(appId, _Fb.version),
      onLoad = _useFb.onLoad,
      fb = _useFb.fb;

  var value = (0, _react.useMemo)(function () {
    return {
      fb: fb,
      appId: appId,
      version: _Fb.version,
      isLoginEnabled: isLoginEnabled
    };
  }, [appId, fb, isLoginEnabled]);
  if (!data) return /*#__PURE__*/_react["default"].createElement(_spin["default"], {
    indicator: /*#__PURE__*/_react["default"].createElement(_LoadingOutlined["default"], {
      spin: true
    })
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !appId ? null : /*#__PURE__*/_react["default"].createElement(_script["default"], {
    id: "fb-sdk-js",
    strategy: "afterInteractive" // TODO: T12549 因突然的事件導致 local render 問題，使用 debug.js 確認可在開發端正常顯示，待後續確認無問題時移除
    ,
    src: process.env.NODE_ENV === 'production' ? 'https://connect.facebook.net/zh_TW/sdk.js' : 'https://connect.facebook.net/zh_TW/sdk/debug.js',
    onLoad: onLoad
  }), /*#__PURE__*/_react["default"].createElement(_Fb["default"].Provider, {
    value: value
  }, children));
});

exports["default"] = _default;